import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ISupplierBatch } from '../interfaces/supplier-batch';
import { ISupplierBatchFilter } from '../interfaces/supplier-batch-filter';
import { ReadService } from './read.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class SupplierBatchService extends ReadService<ISupplierBatch, ISupplierBatchFilter> {
  url = '/api/supplierbatches';
  entityTitle = 'Supplier batch';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  confirmBatch(id: number): Promise<any> {
    return this.http
      .get(`${this.url}` + '/confirmBatch?id=' + id)
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }
}
